namespace advisorop.services {
    `use strict`;

    export class BoxApi {

        readonly apiUrl = `/api/box`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getBoxSubfoldersByHH(
            boxFolderId: string,
            householdId: number): ng.IHttpPromise<any> {
            return this.$http.get(`${this.apiUrl}/household/${householdId}/folder/${boxFolderId}`);
        }

        setBoxHhFolder(
            boxFolderId: string,
            boxFolderPath: string,
            householdId: number): ng.IHttpPromise<any> {
            return this.$http
                .post(`${this.apiUrl}/household/${householdId}`,
                {
                    item1: boxFolderId,
                    item2: boxFolderPath
                });
        }

        getBoxHhFolder(householdId: number): ng.IHttpPromise<any> {
            return this.$http.get(`${this.apiUrl}/household/${householdId}`);
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("boxApi", BoxApi);
}